import '../../lib/globals'

import '../../lib/app'
import URI from 'urijs'
import { peUrlParams } from './peUrlParams'
import { setupBrowserCheck } from './setupBrowserCheck'
import shouldStartSessionOnStart from '../../lib/util/should_start_session_on_start'

import '../../lib/components/skip_to_content'

export function startApp (extraOpts = {}, appendTo = 'body') {
  const params = peUrlParams()

  let disabledFeatures = params.get('disabled') || ''
  disabledFeatures = disabledFeatures.split(',')

  // Extract auth token and remove from browser history (as we can't reuse)
  const sessionAuthToken = params.get('pe_auth_token') || false
  if (sessionAuthToken) {
    const uri = URI(window.location.href)
    window.history.replaceState('', '', uri.removeSearch('pe_auth_token').toString())
  }

  // Generate common options and merge with extra ones
  const opts = Object.assign({
    router: !disabledFeatures.includes('router'),
    debug: params.has('debug'),
    sessionAuthToken,
    shouldStartSessionOnStart: shouldStartSessionOnStart(),
    allowSignups: !disabledFeatures.includes('signups'),
    typekit: true
  }, extraOpts)

  const app = document.createElement('pe-application')
  app.options = opts
  document.querySelector(appendTo).appendChild(app)

  setupBrowserCheck({
    role: opts.role,
    mode: opts.mode,
    appName: opts.appName
  }, app)

  if (opts.typekit) {
    // Delay this just a moment so we can load more important stuff first as
    // browsers limit the number of open connections and typekit kicks off **a lot**
    setTimeout(() => import(/* webpackChunkName: "typekit" */ '../../lib/globals/typekit'), 10)
  }

  return app
}
